import { Box, Typography, useTheme } from '@mui/material';
import React from 'react';

export type InfoRowItem = {
  label: string;
  value: string | number;
};

export const InfoRowWidget = ({ items }: { items: InfoRowItem[] }) => {
  const theme = useTheme();
  return (
    <>
      {items.map(({ label, value }) => (
        <Box
          key={label}
          sx={{
            backgroundColor: theme.palette.purple[800],
            borderRadius: 15,
            px: 3,
            py: 2,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center',
            textAlign: 'left',
            transition: 'transform 0.2s ease-in-out',
            '&:hover': {
              transform: 'scale(1.03)',
            },
          }}
        >
          <Typography variant="body1" sx={{ fontSize: '0.9rem' }}>
            {label}
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 700, fontSize: '1.5rem' }}>
            {value}
          </Typography>
        </Box>
      ))}
    </>
  );
};
